export default "__VITE_ASSET__393vVsRO__"